/**
 *  @class
 *  @function RecentlyViewedProducts
 */
if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();

      this.url = routes.search_url + '?view=recently-viewed&type=product&q=';
      this.container = this.querySelector('.products');
      this.currentId = this.dataset.productId ? String(this.dataset.productId) : null;
      this.max = 8;
      this.swiperEnabled = this.dataset.swiper === 'true';

      if (window.localStorage) {
        let recentIds = window.localStorage.getItem('recently-viewed');
        if (recentIds && recentIds !== 'undefined') {
          window.recentlyViewedIds = JSON.parse(recentIds).map(String);
        } else {
          window.recentlyViewedIds = [];
        }

        if (this.currentId) {
          window.recentlyViewedIds = window.recentlyViewedIds.filter(id => id !== this.currentId);
          window.recentlyViewedIds.unshift(this.currentId);
          if (window.recentlyViewedIds.length > 10) {
            window.recentlyViewedIds.pop();
          }
          window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
        }
      }
    }

    connectedCallback() {
      this.buildUrl();
    }

    buildUrl() {
      if (!window.recentlyViewedIds || window.recentlyViewedIds.length === 0) return;

      let i = 0;
      let handles = [];

      window.recentlyViewedIds.forEach((val) => {
        if (!val) return;
        if (val === this.currentId) return;
        if (i >= this.max) return;

        let strVal = String(val);
        let isHandle = isNaN(strVal) || strVal.includes('-');
        handles.push(isHandle ? 'handle:' + strVal : 'id:' + strVal);
        i++;
      });

      if (handles.length === 0) return;

      this.url = this.url + encodeURIComponent(handles.join(' OR ')) + '&ratio=' + this.imageRatio;
      this.fetchProducts();
    }

    fetchProducts() {
      fetch(this.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.products');

          if (recommendations && recommendations.innerHTML.trim().length) {
            if (this.swiperEnabled) {
              const items = recommendations.querySelectorAll('li.grid__item');
    items.forEach(li => {
                li.classList.remove('grid__item');
                li.classList.add('swiper-slide');
              });            }

            this.container.innerHTML = recommendations.innerHTML;
            this.classList.add('product-recommendations--loaded');

            // Show heading
            const heading = this.querySelector('.rv-heading');
            if (heading) heading.style.display = '';

            // Show outer wrapper
            const wrapper = this.closest('.section-recently-viewed-wrapper');
            if (wrapper) wrapper.classList.add('is-visible');

            // Init swiper after DOM is updated
            if (this.swiperEnabled) {
              this.initSwiper();
            }
          }
        })
        .catch(e => console.error(e));
    }

    initSwiper() {
      const swiperEl = this.querySelector('.rv-swiper');
      if (!swiperEl || typeof Swiper === 'undefined') return;

      const desktop  = parseFloat(this.dataset.desktop)  || 4;
      const laptop   = parseFloat(this.dataset.laptop)   || 4;
      const tablet   = parseFloat(this.dataset.tablet)   || 3;
      const mobile   = parseFloat(this.dataset.mobile)   || 2;
      const gap      = parseInt(this.dataset.gap)      || 20;
      const autoplayDelay = parseInt(this.dataset.autoplay) || 0;
      const showNav  = this.dataset.navigation === 'true';
      const showPagi = this.dataset.pagination === 'true';

      new Swiper(swiperEl, {
        spaceBetween: gap,
        loop: false,
        autoplay: autoplayDelay > 0 ? { delay: autoplayDelay * 1000 } : false,
        navigation: showNav ? {
          nextEl: swiperEl.querySelector('.swiper-button-next'),
          prevEl: swiperEl.querySelector('.swiper-button-prev')
        } : false,
        pagination: showPagi ? {
          el: swiperEl.querySelector('.swiper-pagination'),
          clickable: true
        } : false,
        breakpoints: {
          320:  { slidesPerView: mobile },
          576:  { slidesPerView: tablet },
          991:  { slidesPerView: laptop },
          1200: { slidesPerView: desktop }
        }
      });
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
